<div ngSkipHydration>
<div class="p-4 bg-white" style="font-size: 0.9rem; max-height: 85vh; overflow-y: auto; font-family: 'Segoe UI', system-ui, sans-serif;">
  
  <!-- Encabezado Principal -->
  <div class="pb-3 mb-4 border-bottom d-flex align-items-center justify-content-between">
    <div>
      <h3 class="h5 m-0 fw-bold text-dark text-uppercase" style="letter-spacing: 0.5px;">✏️ Reestructuración Integral del Taller</h3>
      <span class="small text-muted font-monospace" style="font-size: 0.75rem;">SaaS Advanced Customizer Cockpit // Multi-Layer Sync</span>
    </div>
    <span class="badge bg-dark-subtle text-dark border px-3 py-2 rounded-pill font-monospace" style="font-size: 0.75rem;">v2.4-Stable</span>
  </div>

  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" autocomplete="off">

    <!-- 🔒 SECCIÓN 1: DATOS ESTÁTICOS JDE (BLOQUEADOS / SOLO LECTURA) -->
    <div class="mb-4">
      <div class="d-flex align-items-center mb-3 bg-light p-2 rounded-3 border-start border-secondary border-3">
        <span class="fw-bold text-secondary text-uppercase small" style="letter-spacing: 0.5px;">🔒 Parámetros Contables Inmutables (Bloqueados - Solo Consulta)</span>
      </div>
      
      <!-- Fondo contenedor gris para agrupar lo inmutable -->
      <div class="card p-3 bg-light border-0" style="border-radius: 10px; background-color: #f4f5f7 !important;">
        <div class="row g-3 mb-3">
          <div class="col-md-8">
            <div class="form-floating">
              <!-- Estilo unificado para desincentivar el clic y cambiar el cursor -->
              <input type="text" class="form-control border-0 text-muted" id="editCoId" formControlName="coId" readonly 
                     style="background-color: #e9ecef; cursor: not-allowed; font-weight: 400; color: #6c757d !important;">
              <label for="editCoId" class="text-secondary small">UUID Global (co_id)</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control border-0 text-muted text-center" id="editAn8" formControlName="adminAn8" readonly 
                     style="background-color: #e9ecef; cursor: not-allowed; font-weight: 400; color: #6c757d !important;">
              <label for="editAn8" class="text-secondary small">Base AN8 Folio</label>
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <div class="form-floating">
              <input type="text" class="form-control border-0 text-muted text-center" id="editCcco" formControlName="ccco" readonly 
                     style="background-color: #e9ecef; cursor: not-allowed; font-weight: 400; color: #6c757d !important;">
              <label for="editCcco" class="text-secondary small">Company Code (CCCO)</label>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-floating">
              <input type="text" class="form-control border-0 text-muted text-uppercase" id="editMcu" formControlName="mcuBu" readonly 
                     style="background-color: #e9ecef; cursor: not-allowed; font-weight: 400; color: #6c757d !important;">
              <label for="editMcu" class="text-secondary small">Business Unit (MCU)</label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control border-0 text-muted text-center text-uppercase" id="editCrdc" formControlName="crdc" readonly 
                     style="background-color: #e9ecef; cursor: not-allowed; font-weight: 400; color: #6c757d !important;">
              <label for="editCrdc" class="text-secondary small">Divisa</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 🏢 SECCIÓN 2: IDENTIDAD FISCAL Y CONTACTO (EDITABLES) -->
    <div class="mb-4">
      <div class="d-flex align-items-center mb-3 p-2 border-start border-primary border-3" style="background: rgba(13, 110, 253, 0.04);">
        <span class="fw-bold text-primary text-uppercase small" style="letter-spacing: 0.5px;">🏢 Identidad Comercial y Propietario (Habilitados para Editar)</span>
      </div>
      
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="form-floating">
            <!-- 'form-editable' añade el efecto de sombra al pasar el mouse (hover) -->
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editName" formControlName="nameAlpha" placeholder="Razón Social"
                   [ngClass]="{'is-invalid': editForm.get('nameAlpha')?.touched && editForm.get('nameAlpha')?.invalid}">
            <label for="editName" class="text-dark">Razón Social Legal del Taller *</label>
            <div class="invalid-feedback">La razón social es requerida.</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editTax" formControlName="taxId" placeholder="RFC"
                   [ngClass]="{'is-invalid': editForm.get('taxId')?.touched && editForm.get('taxId')?.invalid}">
            <label for="editTax" class="text-dark">RFC / Identificación Fiscal *</label>
            <div class="invalid-feedback">El RFC es obligatorio.</div>
          </div>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editOwner" formControlName="ownerName" placeholder="Dueño"
                   [ngClass]="{'is-invalid': editForm.get('ownerName')?.touched && editForm.get('ownerName')?.invalid}">
            <label for="editOwner" class="text-dark">Nombre del Dueño / Representante *</label>
            <div class="invalid-feedback">El nombre del propietario es mandatorio.</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control bg-white form-editable" id="editPhone" formControlName="supportPhone" placeholder="Tel"
                   [ngClass]="{'is-invalid': editForm.get('supportPhone')?.touched && editForm.get('supportPhone')?.invalid}">
            <label for="editPhone" [ngClass]="(editForm.get('supportPhone')?.touched && editForm.get('supportPhone')?.invalid) ? 'text-danger' : 'text-dark'">Teléfono de Soporte *</label>
            <div class="invalid-feedback">El teléfono es obligatorio.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 👤 SECCIÓN 3: CREDENCIALES DEL ADMINISTRADOR (EDITABLES) -->
    <div class="mb-4 p-3 bg-light border border-secondary-subtle rounded-3" style="border-style: dashed !important;">
      
      <!-- 🌟 NUEVO DIV DE TÍTULO: Estandarizado con barra lateral amarilla como la última versión -->
      <div class="d-flex align-items-center mb-3 p-2 border-start border-warning border-3" style="background: rgba(255, 193, 7, 0.04);">
        <span class="fw-bold text-warning-emphasis text-uppercase small" style="letter-spacing: 0.5px;">👤 Cuenta Máster de Acceso Local (Habilitados para Editar)</span>
      </div>
      
      <!-- Fila de Usuario y Contraseña -->
      <div class="row g-3">
        <div class="col-md-6">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-lowercase form-editable" id="editAdminUser" formControlName="adminUser" placeholder="Usuario">
            <label for="editAdminUser" class="text-dark">Login ID Administrador Local *</label>
            <div class="invalid-feedback">El ID de usuario es mandatorio.</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-floating">
            <input type="password" class="form-control bg-white form-editable" id="editAdminPass" formControlName="adminPassword" placeholder="Pass">
            <label for="editAdminPass" class="text-dark">Nueva Contraseña (Dejar vacío para conservar)</label>
            <div class="invalid-feedback">Mínimo 6 caracteres.</div>
          </div>
        </div>
      </div>

      <!-- Fila del Email Integrado -->
      <div class="row g-3 mt-2">
        <div class="col-12">
          <div class="form-floating">
            <input type="email" class="form-control bg-white form-editable" id="editEmail" formControlName="email" placeholder="correo@empresa.com"
                   (input)="editForm.get('email')?.setValue(editForm.get('email')?.value?.toLowerCase(), {emitEvent: false})"
                   [ngClass]="{'is-invalid': editForm.get('email')?.touched && editForm.get('email')?.invalid}">
            <label for="editEmail" class="text-dark">Correo Electrónico Central *</label>

            <div class="invalid-feedback">
              <span *ngIf="editForm.get('email')?.hasError('required')">El correo electrónico es obligatorio para el taller.</span>
              <span *ngIf="editForm.get('email')?.hasError('email')">Por favor ingrese un formato de correo válido.</span>
              <span *ngIf="editForm.get('email')?.hasError('correoDuplicado')" class="text-danger">
                ⚠️ Correo ya registrado en el sistema. Pertenece a un cliente existente.
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- ⚖️ SECCIÓN 4: PARÁMETROS LEGALES PROFECO (EDITABLES) -->
    <div class="mb-4">
      <div class="d-flex align-items-center mb-3 p-2 border-start border-info border-3" style="background: rgba(13, 202, 240, 0.04);">
        <span class="fw-bold text-info-emphasis text-uppercase small" style="letter-spacing: 0.5px;">⚖️ Perímetro Legal de Conformidad Jurídica (Habilitados para Editar)</span>
      </div>
      
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="form-floating">
            <select class="form-select bg-white text-dark form-editable" id="editTipoTaller" formControlName="tipoTaller">
              <option value="MECANICO">MECANICO</option>
              <option value="LAMINADO">LAMINADO</option>
              <option value="AMBOS">MECANICA Y LAMINADO</option>
            </select>
            <label for="editTipoTaller" class="text-dark">Giro Operativo Autorizado</label>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editRegAdhesion" formControlName="numRegContAdhesion" placeholder="Profeco"
                   [ngClass]="{'is-invalid': editForm.get('numRegContAdhesion')?.touched && editForm.get('numRegContAdhesion')?.invalid}">
            <label for="editRegAdhesion" class="text-dark">No. Registro Contrato Adhesión *</label>
            <div class="invalid-feedback">El registro Profeco es mandatorio.</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-floating">
            <select class="form-select bg-white text-dark form-editable" id="editCuentaSeguro" formControlName="tallerCuentaSeguro">
              <option value="SI">SÍ CUENTA</option>
              <option value="NO">NO CUENTA</option>
            </select>
            <label for="editCuentaSeguro" class="text-dark">Póliza de Responsabilidad</label>
          </div>
        </div>
      </div>
    </div>

    <!-- 📍 SECCIÓN 5: UBICACIÓN GEOGRÁFICA (EDITABLES) -->
    <div class="mb-4">
      <div class="d-flex align-items-center mb-3 p-2 border-start border-success border-3" style="background: rgba(25, 135, 84, 0.04);">
        <span class="fw-bold text-success text-uppercase small" style="letter-spacing: 0.5px;">📍 Dirección e Infraestructura de Envío (Habilitados para Editar)</span>
      </div>
      
      <div class="row g-3 mb-3">
        <div class="col-md-8">
          <div class="form-floating">
            <!-- 'form-editable' activa la sombra premium al pasar el cursor (hover) -->
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editCalle" formControlName="calleNumero" placeholder="Calle"
                   [ngClass]="{'is-invalid': editForm.get('calleNumero')?.touched && editForm.get('calleNumero')?.invalid}">
            <label for="editCalle" class="text-dark">Calle y Número Oficial *</label>
            <div class="invalid-feedback">La dirección es requerida.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-center form-editable" id="editCp" formControlName="codigoPostal" placeholder="CP"
                   [ngClass]="{'is-invalid': editForm.get('codigoPostal')?.touched && editForm.get('codigoPostal')?.invalid}">
            <label for="editCp" class="text-dark">Código Postal *</label>
            <div class="invalid-feedback">Digite un CP válido de 5 dígitos.</div>
          </div>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editColonia" formControlName="colonia" placeholder="Col"
                   [ngClass]="{'is-invalid': editForm.get('colonia')?.touched && editForm.get('colonia')?.invalid}">
            <label for="editColonia" class="text-dark">Colonia / Asentamiento *</label>
            <div class="invalid-feedback">La colonia es obligatoria.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editMun" formControlName="delegacionMunicipio" placeholder="Mun"
                   [ngClass]="{'is-invalid': editForm.get('delegacionMunicipio')?.touched && editForm.get('delegacionMunicipio')?.invalid}">
            <label for="editMun" class="text-dark">Delegación o Municipio *</label>
            <div class="invalid-feedback">El municipio es requerido.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-floating">
            <input type="text" class="form-control bg-white text-uppercase form-editable" id="editEstado" formControlName="estado" placeholder="Edo"
                   [ngClass]="{'is-invalid': editForm.get('estado')?.touched && editForm.get('estado')?.invalid}">
            <label for="editEstado" class="text-dark">Estado / Entidad *</label>
            <div class="invalid-feedback">El estado es requerido.</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Switch de Control de Suscripción -->
    <div class="row g-3 mb-4 align-items-center border-top pt-3">
      <div class="col-12 ps-4">
        <div class="form-check form-switch ps-5">
          <input class="form-check-input shadow-sm" type="checkbox" id="editSwitchEnabled" formControlName="enabled" style="scale: 1.3; cursor: pointer;">
          <label class="form-check-label fw-bold text-success ms-3" for="editSwitchEnabled" *ngIf="editForm.get('enabled')?.value" style="font-size: 0.95rem;">🟢 Suscripción Activa / Con Acceso Operativo</label>
          <label class="form-check-label fw-bold text-danger ms-3" for="editSwitchEnabled" *ngIf="!editForm.get('enabled')?.value" style="font-size: 0.95rem;">🔴 Suscripción Suspendida / Bloqueo de Red</label>
        </div>
      </div>
    </div>

    <!-- Botonera Ejecutiva -->
    <div class="d-flex justify-content-end gap-2 border-top pt-3">
      <button type="button" class="btn btn-light border px-4 py-2 fw-semibold" style="border-radius: 8px; font-size: 0.9rem;" (click)="dialogRef.close(false)">
        Cancelar
      </button>
      <button type="submit" class="btn text-white px-5 py-2 fw-bold shadow-sm" [disabled]="editForm.invalid" [ngClass]="editForm.invalid ? 'btn-secondary opacity-50' : 'btn-dark'" style="border-radius: 8px; font-size: 0.9rem; letter-spacing: 0.3px;">
        💾 Guardar Cambios Integrales
      </button>
    </div>

  </form>
</div>
</div>